import React from "react";
import CustomModal from "components/custom-modal/CustomModal";
import Button from "components/button/Button";
import { AlertCircleIconV1 } from "images/image-component";
import "./error-modal.css";

interface Props {
  isOpen: boolean;
  errorMsg: string;
  handleClose: () => void;
  tryAgain?: () => void;
}

function ErrorModal({ isOpen, handleClose, tryAgain, errorMsg }: Props) {
  return (
    <CustomModal isOpen={isOpen} handleClose={handleClose}>
      <div className="v1-error-modal">

        <div className="v1-error-icon">
          <AlertCircleIconV1 />
        </div>

        <h3 className="v1-error-title">Something went wrong</h3>
        <p className="v1-error-msg">{errorMsg}</p>

        <div className="v1-error-actions">
          {tryAgain && (
            <Button variant="ghost" onClick={tryAgain}>
              Try again
            </Button>
          )}
          <Button variant="subtle" onClick={handleClose}>
            Close
          </Button>
        </div>

      </div>
    </CustomModal>
  );
}

export default ErrorModal;
